<template>
  <el-container class="menulist">
    <div class="menulist-top">
      <el-button type="success" @click="addfather()">添加角色组</el-button>
    </div>
    <el-main class="menulist-content">
      <el-table :data="tableData5" type="selection" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table class="demo-table-expand" :data="scope.row.children" border style="width: 100%">
              <el-table-column prop="groupId" label="所属角色组id" align="center">
              </el-table-column>
              <el-table-column align="center" prop="name" label="角色名">
              </el-table-column>
              <!--<el-table-column align="center" prop="note" label="备注"> </el-table-column>-->
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button size="small" type="success" @click="sonhand(scope.row)">修改
                  </el-button>
                  <el-button size="small" type="danger" @click="sonmenu(scope.row)">分配菜单
                  </el-button>
                  <el-button v-show="scope.row.code != 'admin'" size="small" type="danger"
                    @click="sondel(scope.row)">删除</el-button>
                  <el-button v-show="scope.row.code == 'admin'" size="small" type="danger">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column align="center" label="ID" prop="id"> </el-table-column>
        <el-table-column align="center" label="角色组名" prop="name">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="success" @click="fatheradd(scope.row)">添加子角色
            </el-button>
            <el-button size="small" type="success" @click="fatherhand(scope.row)">修改
            </el-button>
            <el-button v-show="scope.row.code == 'admin'" size="small" type="danger">删除</el-button>
            <el-button v-show="scope.row.code != 'admin'" size="small" type="danger"
              @click="fatherdel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <!-- 添加子角色弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer1" :with-header="false">
        <div class="title">菜单详情</div>
        <el-form :model="addlist" ref="addlist" label-width="100px" class="demo-ruleForm">
          <el-form-item label=" 角色组ID" prop="id">
            <el-input v-model="addlist.id" :disabled="true"></el-input>
          </el-form-item>
          <!-- <el-form-item label="角色code" prop="name">
            <el-input v-model="addlist.code"></el-input>
          </el-form-item> -->
          <el-form-item label="子角色名称" prop="name">
            <el-input v-model="addlist.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addsubmitForm('ruleForm')">添加</el-button>
            <el-button @click="drawer1 = false">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 修改角色组弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false">
        <div class="title">菜单详情</div>
        <el-form :model="editlist" ref="editlist" label-width="100px" class="demo-ruleForm">
          <el-form-item label="ID" prop="id">
            <el-input v-model="editlist.id" :disabled="true"></el-input>
          </el-form-item>
          <!-- <el-form-item label="角色code" prop="name">
            <el-input v-model="editlist.code"></el-input>
          </el-form-item> -->
          <el-form-item label="角色组名" prop="name">
            <el-input v-model="editlist.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onedit('ruleForm')">完成</el-button>
            <el-button @click="drawer = false">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 修改子角色弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer2" :with-header="false">
        <div class="title">菜单详情</div>
        <el-form :model="editsonlist" ref="editlist" label-width="100px" class="demo-ruleForm">
          <el-form-item label=" 角色组ID" prop="id">
            <el-input v-model="editsonlist.id"></el-input>
          </el-form-item>
          <!-- <el-form-item label="角色code" prop="name">
            <el-input v-model="editsonlist.code"></el-input>
          </el-form-item> -->
          <el-form-item label="子角色名称" prop="name">
            <el-input v-model="editsonlist.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="sonedit('ruleForm')">完成</el-button>
            <el-button @click="drawer2 = false">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
    <!-- 分配角色菜单弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer4" :with-header="false">
        <div style="height:100vh;display:flex;flex-direction:column;justify-content:space-between;padding-bottom:30px">
          <div class="title">分配菜单</div>
          <div style="height:80%">
            <el-scrollbar style="height: 100%;width:100%">
              <el-tree :data="data" show-checkbox node-key="id" :default-expanded-keys="expankeys"
                :default-checked-keys="defachecked" :props="defaultPropsMenu" :check-strictly="checkStrictly"
                ref="menuTree">
              </el-tree>
            </el-scrollbar>
          </div>
          <div style="margin:0 auto;height:18%;padding-top:30px">
            <el-button type="primary" @click="distributionon('ruleForm')">完成</el-button>
            <el-button @click="drawer4 = false">退出</el-button>
          </div>
        </div>
      </el-drawer>
    </div>
    <!-- 添加角色组弹出框 -->
    <div class="menulist-add">
      <el-drawer title="我是标题" :visible.sync="drawer3" :with-header="false">
        <div class="title">菜单详情</div>
        <el-form :model="addfatherlist" ref="editlist" label-width="100px" class="demo-ruleForm">
          <!-- <el-form-item label="角色code" prop="name">
            <el-input v-model="addfatherlist.code"></el-input>
          </el-form-item> -->
          <el-form-item label="角色组名" prop="name">
            <el-input v-model="addfatherlist.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addfatherliston('ruleForm')">完成</el-button>
            <el-button @click="drawer3 = false">退出</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>
  </el-container>
</template>

<script>
import {
  api_getperuserinfo,
  api_get_admin_resource,
  api_addperuserinfo,
  api_updateperuserinfo,
  api_delperuserinfo,
  api_postresources,
  api_delresources,
  api_editresources,
  api_get_role_sources,
  api_add_role_sources
} from "@/api/permissions.js";
export default {
  data() {
    return {
      //总数据
      tableData5: [],
      addfatherlist: {}, //添加角色组数据
      addlist: {}, //添加子角色数据
      editlist: {}, //修改角色组数据
      editsonlist: {}, //修改子级角色数据
      drawer1: false, //添加子角色
      drawer: false, //修改角色组弹出框
      drawer2: false, //修改子角色弹出框
      drawer3: false, //添加角色组出框
      drawer4: false, //分配角色菜单弹出框
      expankeys: [], //权限树默认展开数组
      defachecked: [], //权限树默认选中数组\
      checkStrictly: true, //tree 父子不关联
      data: [], //权限树菜单
      defaultPropsMenu: {
        children: "children",
        label: "name"
      }, //改变权限树名字显示字段
      ID: 1 //当前子菜单ID
    };
  },
  methods: {
    //添加角色组
    addfather(row) {
      this.drawer3 = true;
    },
    //添加角色组提交按钮
    async addfatherliston() {
      if (!this.addfatherlist.name) {
        this.$message.error("角色组名不能为空");
        return false;
      } else {
        let res = await api_addperuserinfo({
          code: this.addfatherlist.code,
          name: this.addfatherlist.name,
          note: this.addfatherlist.note
        });
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist();
          this.drawer3 = false;
        } else {
          this.$message.error(res.message);
        }
      }
    },
    //角色组修改按钮
    fatherhand(row) {
      this.drawer = true;
      this.editlist = { ...row };
    },
    //角色组修改提交按钮
    async onedit() {
      let res = await api_updateperuserinfo(this.editlist);
      if (res.code == 0) {
        this.$message({
          message: "成功",
          type: "success"
        });
        this.permissionlist(); //重绘视图
        this.drawer = false;
      } else {
        this.$message.error(res.message);
      }
    },
    //角色组删除按钮
    fatherdel(row) {
      this.$confirm("是否要删除父菜单", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(async () => {
        let res = await api_delperuserinfo(row.id);
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist(); //重绘视图
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //角色组添加子角色弹出框
    fatheradd(row) {
      this.drawer1 = true;
      this.addlist = { ...row };
      this.addlist.code = "";
      this.addlist.note = "";
      this.addlist.name = "";
    },
    //添加子角色提交按钮
    async addsubmitForm() {
      if (this.addlist.name == "") {
        this.$message.error("子角色名不能为空");
        return false;
      } else {
        let res = await api_postresources({
          groupId: this.addlist.id,
          name: this.addlist.name,
          note: this.addlist.note,
          code: this.addlist.code
        });
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist();
          this.drawer1 = false;
        } else {
          this.$message.error(res.message);
        }
      }
    },
    //子角色修改按钮
    sonhand(row) {
      this.drawer2 = true;
      this.editsonlist = { ...row };
    },
    //子级菜单修改弹出框提交按钮
    async sonedit() {
      let res = await api_editresources(this.editsonlist);
      if (res.code == 0) {
        this.$message({
          message: "成功",
          type: "success"
        });
        this.permissionlist(); //重绘菜单试图
        this.drawer2 = false;
      } else {
        this.$message.error(res.message);
      }
    },
    //子角色删除按钮
    sondel(row) {
      this.$confirm("是否要删除子菜单", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      }).then(async () => {
        let res = await api_delresources(row.id);
        if (res.code == 0) {
          this.$message({
            message: "成功",
            type: "success"
          });
          this.permissionlist(); //重绘菜单试图
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取当前所有角色组
    async permissionlist() {
      let res = await api_getperuserinfo();
      this.tableData5 = res.data;
    },
    //获取菜单权限树
    async getrolemenusources() {
      let res = await api_get_admin_resource();
      this.data = res.data;
    },
    //分配子角色菜单
    async sonmenu(row) {
      this.ID = row.id;
      this.checkStrictly = true;
      this.drawer4 = true;
      let res = await api_get_role_sources({
        roleId: row.id
      });
      this.getrolemenusources();
      this.expankeys = res.data;
      this.defachecked = res.data;
      if (res.code == 0) {
        setTimeout(() => {
          this.checkStrictly = false;
        }, 500);
      } else {
        return false;
      }
    },
    //分配菜单提交按钮
    async distributionon() {
      let resarr = this.$refs.menuTree
        .getCheckedKeys()
        .concat(this.$refs.menuTree.getHalfCheckedKeys()); //获取当前选中treebox 的ID数组
      let res = await api_add_role_sources({
        roleId: this.ID,
        resourceIdList: resarr
      });
      if (res.code == 0) {
        this.$message({
          message: "成功",
          type: "success"
        });
        this.drawer4 = false;
      } else {
        this.$message.error(res.message);
      }
    }
  },
  mounted() {
    this.permissionlist(); //获取数据
  }
};
</script>


<style lang="less" scoped>
.menulist {
  height: 100%;
  display: flex;
  flex-direction: column;

  .menulist-top {
    margin-bottom: 16px;
    padding: 20px;
    background: #fff;
  }
  .menulist-content {
    margin: 0 16px;
    padding: 10px 20px;
    background: #fff;
  }
  .menulist-add {
    .title {
      font-size: 26px;
      font-weight: bolder;
      color: blueviolet;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
